            <!-- Геозоны низ -->
<div class="tabpage geozones hidden" id="geozones_bottom">
  <div class="blockheader">{{'Geozone information'|translate }}</div>
  <div class="tablewrap">
    <div class="table">
      <table>
        <tr><td>{{'Name'| translate }}</td><td><span id="zonename"></span></td></tr>
        <tr><td>{{'Description'| translate }}</td><td><span id="zonecomment"></span></td></tr>
        <tr><td>{{'Groups'|translate }}</td><td><span id="zonegroupslist"></span></td></tr>
        <tr><td>{{'Speed limit'|translate }}</td><td><span id="zonemaxspeed"></span></td></tr>
        <tr><td>{{'Type'|translate }}</td><td><span id="zonetype"></span></td></tr>
        <tr><td>{{'Events'|translate }}</td><td><span id="zoneevents"></span></td></tr>
        <tr><td>{{'Use in reports'|translate }}</td><td><span id="zoneuseinreports"></span></td></tr>
      </table>
    </div>
  </div>
</div>
<!-- Геозоны низ настройки -->
<!--div class="tabpage geozones geozonessettings hidden" id="geozones_bottom_settings">
    <div class="btn_tabs">
        <a href="#" class="active" onclick="openTab4()">Параметры зоны</a>
        <a href="#" onclick="openTab4()">Стилизация зоны</a>
    </div>
    <div class="tablewrap">
        <div class="table">
            <div class="inputgroup">
                <label>{{'Name'|translate}}</label><input type="text" />
            </div>
            <div class="inputgroup">
                <label>Описание</label><input type="text" />
            </div>
            <div class="inputgroup">
                <label>Допустимая скорость</label><input class="minwidth" type="text" /><label>км/ч</label>
            </div>
            <div class="separator"></div>
            <div class="twoinputgroup">
                <div class="inputgroup">
                    <label>Тип зоны</label>
                    <div class="dropdown dropup dropclick">
                        <input type="text" readonly="readonly" value="1" />
                        <ul>
                            <li>2</li>
                            <li>3</li>
                            <li>4</li>
                        </ul>
                    </div>
                </div>
                <div class="inputgroup">
                    <label>События</label>
                    <div class="dropdown dropup dropclick">
                        <input type="text" readonly="readonly" value="1" />
                        <ul>
                            <li>2</li>
                            <li>3</li>
                            <li>4</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="setting_btns">
        <button class="btn_blue">{{ 'Save'| translate }}</button>
        <button class="btn_lgray">{{ 'Cancel'| translate }}</button>
    </div>
</div-->
